module.exports = __webpack_public_path__ + "8c48651306a34c5798b632351cfe4980.png";